import React from 'react';
import Banner from '@components/Banner/banner';
import AuditOne from './sections/AuditOne';
import AuditTwo from './sections/AuditTwo';
import AuditThree from './sections/AuditThree';
import AuditFour from './sections/AuditFour';
import AuditFive from './sections/AuditFive';
import AuditSix from './sections/AuditSix';
import AuditSeven from './sections/AuditSeven';
import AuditEight from './sections/AuditEight';
import Footer from '@components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function Audit() {
  const { t } = useTranslation('audit');
  return (
    <>
      <Banner title={t('audit.title')} paragraph={t('audit.subtitle')} />
      <AuditOne />
      <AuditTwo />
      <AuditThree />
      <AuditFour />
      <AuditFive />
      <AuditSix />
      <AuditSeven />
      <AuditEight />
      <Footer />
    </>
  );
}
export default Audit;
